module.exports = __webpack_public_path__ + "static/media/iceburg-lettuce.77853842.png";